import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorModalComponent } from '../../../shared/components/error-modal/error-modal.component';
import { EMAIL_REGEX } from '../../../core/regex/validators-regex';
import { ShareToUsersService } from '../../services/share-to-users-service';
import { DetailFormService } from '../detail-form/detail-form.service';
import { BaseComponent } from '../base-component';


@Component({
  selector: 'common-share-to-users',
  templateUrl: './share-to-users.component.html',
  styleUrls: ['./share-to-users.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareToUsersComponent extends BaseComponent {
  users: Array<string>;
  frm: UntypedFormGroup;
  entityId: string;
  constructor(fb: UntypedFormBuilder,
    private service: ShareToUsersService,
    private cdr: ChangeDetectorRef,
    detailService: DetailFormService
  ) {
    super();
    this.users = [];
    this.frm = fb.group({
      UserEmail: [null,
        [
          Validators.required,
          Validators.pattern(EMAIL_REGEX),
          this.validateNotInList(this.users)
        ]
      ]
    });
    this.addSubscription(detailService.value$.subscribe(value => {
      if (!value || !value.Users || !Array.isArray(value.Users)) {
        this.entityId = null;
        this.users = [];
        return;
      }
      
      this.users = value.Users.map(u => u.UserEmail);
      this.entityId = detailService.id;
      const userEmailControl = this.frm.get('UserEmail');
      const validators = userEmailControl.validator ? [userEmailControl.validator, this.validateNotInList(this.users)] : [this.validateNotInList(this.users)];
      userEmailControl.setValidators(validators);
      userEmailControl.updateValueAndValidity();
      cdr.detectChanges();
    }));
  }

  async onSubmit() {
    const userEmailControl = this.frm.get('UserEmail');
    if (this.frm.valid) {
      try {
        await this.service.postNewUser(this.entityId, userEmailControl.value).toPromise();
      } catch (error) {
        ErrorModalComponent.show(error, this.frm);
        return;
      }
      this.users.push(this.frm.get('UserEmail').value);
      userEmailControl.setValue(null);
      userEmailControl.markAsUntouched();
      this.cdr.detectChanges();
    }
  }

  async clickDelete(userEmail: string) {
    try {
      await this.service.deleteUser(this.entityId, userEmail).toPromise();
    } catch (error) {
      ErrorModalComponent.show(error, this.frm);
      return;
    }
    this.users.splice(this.users.indexOf(userEmail), 1);
    this.cdr.detectChanges();
  }

  validateNotInList(list: Array<string>) {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const value = control.value;
        const isInList = list.includes(value);
        return isInList ? { 'emailList': {value: value}} : null;
    };
}

}
